(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviewslider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof $ !== 'undefined' && $('.review_slidebox').length) {
    $('.review_slidebox').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      speed: 400,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviewslider2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof $ !== 'undefined' && $('.review_slidebox').length) {
    $('.review_slidebox').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      speed: 400,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-sliders"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof $ !== 'undefined' && $('.main_testislides').length) {
    var $slider = $('.main_testislides');
    // Initialize slick
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 400,
      prevArrow: $('.testi-prev'),
      nextArrow: $('.testi-next'),
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });

    function updateLastActive() {
      $slider.find('.slick-slide').removeClass('last-active');
      var $activeSlides = $slider.find('.slick-active');
      $activeSlides.last().addClass('last-active');
    }

    $slider.on('init afterChange', function () {
      updateLastActive();
    });

    $slider.on('setPosition', function () {
      updateLastActive();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
